import React from 'react';
import { Menu, Icon, Button } from 'antd';
import { MDBNavbar,  MDBNavbarNav, MDBNavItem, MDBNavLink, MDBCollapse } from 'mdbreact';
import { Link } from 'react-router-dom';
import 'antd/dist/antd.css';
import '../sidemenu.css';
import '../report.css';
import {reactLocalStorage} from 'reactjs-localstorage';
import "react-notifications-component/dist/theme.css";
import 'semantic-ui-css/semantic.min.css';
import { Header } from 'semantic-ui-react'
import Modal from 'react-modal';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import i18n from '../i18n';
import {connect} from 'react-redux';
import HamburgerMenu from 'react-hamburger-menu';



const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};


  class MenuSideWebCMS extends React.Component {
  

    constructor() {
      super();
  
      this.state = {
        modalIsOpen: false,
        show:false,
        collapsed: false,
         collapseID : ''
        
      };
  
      this.openModal = this.openModal.bind(this);
      this.afterOpenModal = this.afterOpenModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
    }
  
    openModal() {
      this.setState({modalIsOpen: true});
    }
  
    afterOpenModal() {
      // references are now sync'd and can be accessed.
      this.subtitle.style.color = '#f00';
    }
  
    closeModal() {
      this.setState({modalIsOpen: false});
    }
  
    state = { activeIndex: 0 }
    handleClick = (e, titleProps) => {
   const { index } = titleProps
   const { activeIndex } = this.state
   const newIndex = activeIndex === index ? -1 : index

   this.setState({ activeIndex: newIndex })
 }
OpenDashboard=()=>{
}

componentDidMount()
{
  reactLocalStorage.get('authenticated');
  reactLocalStorage.get('accessToken');
 
  var lang=i18n.language;
  if(lang ==="ar")
  {
    
    document.querySelector('.main_div_loading').style = 'direction:rtl';
    document.querySelector('.menu_header').style = 'margin-right:14%';
    document.querySelector('.ant-menu').style = 'text-align:right';
    document.querySelector('.text_style').style = 'text-align:right;width: 20%;margin-right: 14%';
  }

  
    
    
/*  if(reactLocalStorage.get('authenticated') === 'false' )
  {
    document.querySelector('.main_div_loading').style = 'display:none';
    window.location="/app";
  }
  else
  {
s  document.querySelector('.main_div_loading').style = 'display:block';
  }

*/
}


   




    toggleCollapse = collapseID => () => {
      this.setState(prevState => ({ collapseID: (prevState.collapseID !== collapseID ? collapseID : '') }));
    }


    toggleCollapsed = () => {
      this.setState({  collapsed: !this.state.collapsed,});

      if(this.state.collapsed)
      {
        document.querySelector(".actionMenu").style = "width:84.5%";
        document.querySelector(".menu_new").style = "margin-left: 19%;margin-top: 10%;";
        document.querySelector(".header_logo_web").style = "width: 13em;";
        document.querySelector(".logo_header").style =
        "display:inline-block !important";
            document.querySelector('.bar_chart').style = 'zoom:1.5 !important';
            document.querySelector(".menuWeb").style =
            "width:17%;";
       //      document.querySelector('.menu_header').style = 'margin-left: 8%;margin-top: 0.552857em !important;width:16% !important';

      }else
       {
        document.querySelector(".menu_new").style = "margin-left: 28%;margin-top: 27%;";
      document.querySelector(".actionMenu").style = "width:94.5%;margin-left: 7% !important;";
      document.querySelector(".menuWeb").style = "width:5.3%;background-color: #292828;";
      document.querySelector(".logo_header").style = "display:none !important";
      document.querySelector(".header_logo_web").style = "width: 4em;";
//          document.querySelector('.menu_header').style = 'margin-top: 15% !important;width:48% !important;margin-left: 30% !important';


      }

}








    render() {
      const { activeIndex } = this.state
  
      return (
<div className="main_div_loading">




<div className="menu_mobile_hidden">
  <MDBNavbar color="green lighten-4"  light>

    <div style={{display: "inline-flex" , width:" 100%" , borderBottom: "1px solid rgb(178, 37, 173)"}}>
    <div style={{ width:" 50%"}}>
      <img src={require('../pictures/ZB logo-02.png')} className="logo_header_mobile" alt="logo" onClick={this.openModal} style={{ cursor:'pointer'}}/>
      </div>
      <div style={{ width: " 18%",marginLeft: '55%',marginTop: '1%;'}}>
           
  <HamburgerMenu
    isOpen={this.state.open}
    menuClicked={this.toggleCollapse("navbarCollapse13")}
    width={27}
    height={15}
    strokeWidth={1}
    rotate={0}
    color='#dfdfdf'
    borderRadius={0}
    animationDuration={0.5}
    className="menu_new menu_mobile"
    style={{ marginTop: '10%',marginLeft:' 16%'}}
    
/>
              </div>
    </div>

      <MDBCollapse id="navbarCollapse13" isOpen={this.state.collapseID} navbar>
        <MDBNavbarNav left>

        <MDBNavItem active >
            <MDBNavLink to="/app/Adds"  onClick={this.toggleCollapse('navbarCollapse13')}>{i18n.t('Advertising.label')}</MDBNavLink>
          </MDBNavItem>


          <MDBNavItem >
            <MDBNavLink to="/app">{i18n.t('Logout.label')}</MDBNavLink>
          </MDBNavItem>

        </MDBNavbarNav>
      </MDBCollapse>
  </MDBNavbar>

</div>






<div className="menu_web">
<div className="menuWeb">

  <Header floated='left' className="header_logo_web">
        <img src={require('../pictures/ZB logo-02.png')} className="logo_header" alt="logo" onClick={this.openModal} style={{ cursor:'pointer'}} />
        <div  className="menu_new">
          <HamburgerMenu
            isOpen={this.state.open}
            menuClicked={this.toggleCollapsed.bind(this)}
            width={27}
            height={15}
            strokeWidth={1}
            rotate={0}
            color='#dfdfdf'
            borderRadius={0}
            animationDuration={0.5}
 
        />
          </div>
  </Header>

          <Menu
        mode="inline"
        theme="dark"
        inlineCollapsed={this.state.collapsed}
            >



          <Menu.Item key="81" >
            <Link to="/app/Adds">
              <Icon type="cloud-upload" className="bar_chart"/>
              <span className="emptyMenu">{i18n.t('Advertising.label')}</span>
             </Link>

            </Menu.Item>


  




      


            <Menu.Item key="7" >
            <Link to="/app">  <Icon type="logout" className="logout_icon"/>
              <span className="emptyMenu">{i18n.t('Logout.label')}</span></Link>
            </Menu.Item>

        </Menu>
        </div>














<div className="modal_ads">

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <h2 ref={subtitle => this.subtitle = subtitle}></h2>
          <br/>
          <div className="slider_auth">
          <div>
            <Carousel style={{width:'20%'}}
              arrowLeft={<Icon className="icon-example" type="left-circle" style={{ zoom:'2', padding: '3px'}}/>}
              arrowRight={<Icon className="icon-example" type="right-circle" style={{ zoom:'2' , padding: '3px'}}/>}
              addArrowClickHandler
            >
              <img src={require('../pictures/slider.jpg')} className="slider_pic"/>
              <img src={require('../pictures/slider2.jpg')} className="slider_pic"/>
              <img src={require('../pictures/slider3.png')} className="slider_pic"/>
            </Carousel>
          </div>
          </div>
          <Button  onClick={this.closeModal} className="close_btn">{i18n.t('Close.label')}</Button>

        </Modal>
</div>






</div>
</div>
      );
    }
  }
  const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps)(MenuSideWebCMS);
